// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@/assets/rem.js";
import store from "../src/store/index";
import Vue from "vue";
import Vant from "vant";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";
import "vant/lib/index.css";
import App from "./App";
import router from "./router";
import "@/font/font.css";
import Utils from "@/utils/index";
import "../static/scss/tenant/tenant.css";
import "../static/scss/default.scss";
import * as VueGoogleMaps from "vue2-google-maps";
import VueCorvova from "vue-cordova";
import VTrack from "v-track"
import trackEvents from "./track-events"

Vue.prototype.$box = Utils;

Vue.use(VueCorvova);
Vue.use(Vant);
Vue.use(ElementUI, { locale });
Vue.config.productionTip = false;
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBy3UZkphCN4GX3unEqN-zLKP358CtlG2s",
    libraries: "places"
  }
});
Vue.use(VTrack, {
  trackEvents,
  trackEnable: {
    UVPV: false,
    TONP: true
  }
})
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js